export default __webpack_public_path__ + "static/media/parallax-min.155b50b0.jpg";